export default "__VITE_ASSET__BLhWBf5J__"